import { InvoiceDto } from "../models"
import { PatchPayload } from "../../pricing/services"

export const ACTION_TYPES = {
    PATCH_INVOICE: "PATCH_INVOICE" as const,
    PATCH_INVOICE_SUCCESS: "PATCH_INVOICE_SUCCESS" as const,
}

export type Actions =
    | { type: typeof ACTION_TYPES.PATCH_INVOICE, payload: PatchPayload}
    | { type: typeof ACTION_TYPES.PATCH_INVOICE_SUCCESS, payload: InvoiceDto}


// WEBPACK FOOTER //
// ./src/state/invoice/actions/types.ts